import type { IconName } from '@frontend/web-react/components/Primitives/Icon/helpers';

export const PROFILE_WIZARD_STEP = {
  address: 'address',
  birthday: 'birthday',
  phoneNumber: 'phoneNumber',
} as const;

export type ProfileWizardStep = (typeof PROFILE_WIZARD_STEP)[keyof typeof PROFILE_WIZARD_STEP];

export type ProfileWizardState = {
  completedSteps: ReadonlyArray<ProfileWizardStep>;
  currentStep: ProfileWizardStep;
};

export type ProfileWizardAction =
  | { completedSteps: ReadonlyArray<ProfileWizardStep>; type: 'syncApiSteps' }
  | { step: ProfileWizardStep; type: 'goToStep' }
  | { type: 'completeCurrentStep' };

export type ProfileWizardStepConfig = {
  description: string;
  icon: IconName;
  step: ProfileWizardStep;
  title: string;
};
